import React, { useState } from "react";
import { Box, Typography, MenuItem, TextField } from "@mui/material";
import AdminPageLayout from "../../components/FullPageLayout/AdminPageLayout";
import { visionEmailAlerts } from "../../constants";
import useScopedTranslation from "../../hooks/useScopedTranslation";

const EmailAlertsFilter = ({ alertType, onChange }) => {
  const t = useScopedTranslation("communications.emailAlerts");

  return (
    <Box display="flex" flex={1} alignItems="center">
      <Box mr={3}>
        <Typography variant="h5">{t("selectEmailAlert")}</Typography>
      </Box>
      <Box minWidth={300}>
        <TextField
          select
          value={alertType}
          onChange={({ target: { value } }) => onChange(value)}
          variant="filled"
          InputProps={{
            disableUnderline: true
          }}
          fullWidth
          id="status-filter"
          hiddenLabel
        >
          {visionEmailAlerts.map(emailAlertType => (
            <MenuItem key={emailAlertType} value={emailAlertType}>
              {t(`alertTypes.${emailAlertType}`)}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </Box>
  );
};

const EmailAlerts = ({}) => {
  const t = useScopedTranslation("communications.emailAlerts");
  const [emailAlertType, setEmailAlertType] = useState("");

  const handleTypeChange = value => {
    console.log(value);
    setEmailAlertType(value);
  };

  return (
    <AdminPageLayout title={t("title")}>
      <Box display="flex" flexDirection="column" mt={4}>
        <EmailAlertsFilter
          alertType={emailAlertType}
          onChange={handleTypeChange}
        />
      </Box>
    </AdminPageLayout>
  );
};

export default EmailAlerts;
